export function generatePath(path: string) {
  if (path.startsWith('/')) {
    path = path.replace('/', '');
  }

  return window.global_url_base + path;
}
